import React from 'react';
import { connect } from 'react-redux';
import { Well, Tabs, Tab } from 'react-bootstrap';

class GovernancePane extends React.Component {
  constructor() {
    super();
  }
  render() {
    if ((this.props.loadingData) && (this.props.loadingData.total)
      && (this.props.loadingData.loaded) && (this.props.loadingData.loaded.size
        !== this.props.loadingData.total) && this.props.isLoading) {
      return <Well>
        Loading
      </Well>;
    }
    if ((this.props.currentFeature) && (this.props.currentFeature.properties)) {
      return <Well className="h6">
        <Tabs defaultActiveKey={1} id="constituency-info">
          <Tab eventKey={1} title="General">
            {
              (this.props.currentFeature.properties.description) ? (
                <Well>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.props.currentFeature.properties.description
                    }} />
                </Well>
              ) : (
                  <Well>
                    No general information for this area
                </Well>
                )
            }
          </Tab>
          <Tab eventKey={2} title="Local Body">
            {
              (this.props.currentFeature.properties.corporator) ? (
                <Well>
                  <dl>
                    <dt>Name</dt>
                    <dd>{this.props.currentFeature.properties.corporator.name}</dd>
                    <dt>Address</dt>
                    <dd>{this.props.currentFeature.properties.corporator.address}</dd>
                    <dt>Phone</dt>
                    <dd>{this.props.currentFeature.properties.corporator.phone}</dd>
                  </dl>
                </Well>
              ) : (
                  <Well>
                    No local body information for this area
                </Well>
                )
            }
          </Tab>
          <Tab eventKey={3} title="State Assembly">
            {
              (this.props.currentFeature.properties.mla) ? (
                <Well>
                  <dl>
                    <dt>Name</dt>
                    <dd>{this.props.currentFeature.properties.mla.name}</dd>
                    <dt>Address</dt>
                    <dd>{this.props.currentFeature.properties.mla.address}</dd>
                    <dt>Phone</dt>
                    <dd>{this.props.currentFeature.properties.mla.phone}</dd>
                  </dl>
                </Well>
              ) : (
                  <Well>
                    No local body information for this area
                </Well>
                )
            }
          </Tab>
          <Tab eventKey={4} title="Parliament">
            {
              (this.props.currentFeature.properties.mp) ? (
                <Well>
                  <dl>
                    <dt>Name</dt>
                    <dd>{this.props.currentFeature.properties.mp.name}</dd>
                    <dt>Address</dt>
                    <dd>{this.props.currentFeature.properties.mp.address}</dd>
                    <dt>Phone</dt>
                    <dd>{this.props.currentFeature.properties.mp.phone}</dd>
                  </dl>
                </Well>
              ) : (
                  <Well>
                    No local body information for this area
                </Well>
                )
            }
          </Tab>
        </Tabs>
      </Well>;
    }
    return <Well>
      No governance information available for this area
    </Well>;
  }
}

export default connect((state) => {
  return {
    currentFeature: state.governanceData.currentFeature,
    isLoading: state.governanceData.isLoading,
    loadComplete: state.governanceData.loadComplete,
    loadingData: state.governanceData.loadingData
  };
})(GovernancePane);



// WEBPACK FOOTER //
// ./src/components/governance/Pane.js